import Vue from "vue";
import VueI18n from "vue-i18n";

import messages from "./messages";

Vue.use(VueI18n);

const savedLang = localStorage.getItem("lang");
const i18n = new VueI18n({
  locale: savedLang ? savedLang : "sk",
  messages
});

i18n.hasLocale = locale => {
  for (const key in i18n.availableLocales) {
    if (locale === i18n.availableLocales[key]) {
      return true;
    }
  }
  return false;
};

i18n.setLocale = locale => {
  if (typeof locale === "string") {
    locale = locale.toLocaleLowerCase();
    if (i18n.hasLocale(locale)) {
      i18n.locale = locale;
      return true;
    }
  }
  return false;
};

export default i18n;
